import _pick from 'lodash/pick';

const FIELDS = [
  'description',
  'externalId',
  'id',
  'name',
  'orgId',
  'rowVersion'
];

export const sanitize = values => {
  const { id, rowVersion, orgId, ...initialValues } = _pick(values, FIELDS);
  if (id) {
    return {
      ...initialValues,
      id,
      rowVersion
    };
  }
  return {
    ...initialValues,
    orgId
  };
};
